<template>
  <v-card tile>
    <div class="ma-0 pa-0">
      <v-alert
        class="mb-0 alert-message w-100"
        density="compact"
        :type="alertType"
        @click.stop="onClose"
      >
        <template v-slot:prepend>
          <v-icon class="text-accent">mdi-alert-circle</v-icon>
        </template>

        <template v-slot:default>
          <span class="text-accent text-body-2 font-weight-medium pl-2 pr-2">{{
            errItem.message
          }}</span>
        </template>

        <template v-slot:append>
          <v-btn
            size="small"
            variant="text"
            @click.stop="showDetails = !showDetails"
            class="text-accent"
            >{{ $t("common.error.more") }}...</v-btn
          >
        </template>

        <template v-slot:close>
          <v-icon class="text-accent" @click.stop="onClose"
            >mdi-close-circle</v-icon
          >
        </template>
      </v-alert>
    </div>
    <v-card-text v-if="showDetails" class="ma-0 pa-2">
      <v-col>
        <v-row>
          <v-col>
            <span class="text-accent">
              <b>{{ $t("common.error.causedBy") }}:</b>
              {{ errItem.causedBy }}
            </span>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <span
              v-if="errItem.requestMethod && errItem.requestUri"
              class="mb-0 text-accent"
            >
              <b>{{ $t("common.error.request") }}:</b>
              {{ errItem.requestMethod }}&nbsp;{{ errItem.requestUri }}
            </span>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <span v-if="errItem.details" class="mb-0 text-accent">
              <b>{{ $t("common.error.details") }}:</b>
              {{ errItem.details }}
            </span>
          </v-col>
        </v-row>
      </v-col>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: ["errItem", "type"],
  emits: ["dismissed"],
  data() {
    return {
      showDetails: false
    }
  },
  methods: {
    onClose() {
      this.$emit("dismissed")
    }
  },
  computed: {
    alertType() {
      if (this.type !== undefined) {
        return this.type
      } else {
        return "warning"
      }
    }
  }
}
</script>
